import React, { useState } from 'react';

const S = {
  topbar:    { display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:20 },
  h1:        { fontSize:20, fontWeight:700, color:'#0D1F1A' },
  grid2:     { display:'grid', gridTemplateColumns:'1fr 1fr', gap:16, marginBottom:16 },
  card:      { background:'white', borderRadius:12, border:'1px solid #E4EDE8', marginBottom:16 },
  cardHdr:   { padding:'12px 16px', borderBottom:'1px solid #E4EDE8', display:'flex', justifyContent:'space-between', alignItems:'center' },
  cardTitle: { fontSize:13, fontWeight:700, color:'#0D1F1A' },
  cardBody:  { padding:16 },
  field:     { marginBottom:14 },
  label:     { display:'block', fontSize:11, fontWeight:700, color:'#7A8F89', textTransform:'uppercase', letterSpacing:0.5, marginBottom:5 },
  input:     { width:'100%', background:'#F0F4F0', border:'1.5px solid #E4EDE8', borderRadius:10, padding:'10px 12px', fontSize:13, color:'#0D1F1A', outline:'none', fontFamily:'inherit', boxSizing:'border-box' },
  inputFocus:{ borderColor:'#075E54' },
  btnSave:   { padding:'9px 20px', borderRadius:10, border:'none', background:'#075E54', color:'white', fontSize:13, fontWeight:700, cursor:'pointer', fontFamily:'inherit' },
  btnGray:   { padding:'9px 20px', borderRadius:10, border:'1px solid #E4EDE8', background:'#F0F4F0', color:'#7A8F89', fontSize:13, cursor:'pointer', fontFamily:'inherit', marginRight:8 },
  success:   { background:'#E1F5EE', border:'1px solid #5DCAA5', borderRadius:10, padding:'10px 14px', fontSize:12, color:'#085041', marginBottom:14 },
  danger:    { background:'#FCEBEB', border:'1px solid #F09595', borderRadius:10, padding:'10px 14px', fontSize:12, color:'#A32D2D', marginBottom:14 },
  divider:   { height:1, background:'#E4EDE8', margin:'14px 0' },
  toggleRow: { display:'flex', justifyContent:'space-between', alignItems:'center', padding:'10px 0', borderBottom:'1px solid #E4EDE8' },
  toggleLbl: { fontSize:13, color:'#0D1F1A' },
  toggleSub: { fontSize:11, color:'#7A8F89', marginTop:2 },
  toggle:    { width:40, height:22, borderRadius:11, cursor:'pointer', border:'none', position:'relative', transition:'background .2s', flexShrink:0 },
};

export default function Configuracion() {
  // Datos del negocio
  const [negocio, setNegocio]   = useState({ nombre:'WhatMarket', email:'admin@whatmarket.com', tel:'+52 33 0000 0000', dominio:'whatmarket.pixcovery.mx' });
  const [msgNegocio, setMsgNegocio] = useState('');

  // Credenciales
  const [creds, setCreds]       = useState({ usuarioActual:'admin', nuevoUsuario:'', passActual:'', passNueva:'', passConfirm:'' });
  const [msgCreds, setMsgCreds] = useState('');
  const [errorCreds, setErrorCreds] = useState('');

  // Notificaciones
  const [notif, setNotif] = useState({
    pagoVencido:   true,
    proximoVencer: true,
    nuevaRegistro: true,
    waPagoVencido: true,
  });

  function guardarNegocio() {
    if (!negocio.nombre.trim()) { setMsgNegocio(''); return; }
    setMsgNegocio('✅ Datos del negocio guardados correctamente');
    setTimeout(() => setMsgNegocio(''), 3000);
  }

  function guardarCreds() {
    setMsgCreds(''); setErrorCreds('');
    if (!creds.passActual) { setErrorCreds('Escribe tu contraseña actual'); return; }
    if (creds.passActual !== 'whatmarket2026') { setErrorCreds('Contraseña actual incorrecta'); return; }
    if (creds.passNueva && creds.passNueva !== creds.passConfirm) { setErrorCreds('Las contraseñas nuevas no coinciden'); return; }
    if (creds.passNueva && creds.passNueva.length < 8) { setErrorCreds('La contraseña debe tener al menos 8 caracteres'); return; }
    setMsgCreds('✅ Credenciales actualizadas correctamente');
    setCreds(prev => ({ ...prev, passActual:'', passNueva:'', passConfirm:'' }));
    setTimeout(() => setMsgCreds(''), 3000);
  }

  function toggleNotif(key) {
    setNotif(prev => ({ ...prev, [key]: !prev[key] }));
  }

  return (
    <div>
      <div style={S.topbar}>
        <h1 style={S.h1}>Configuración</h1>
      </div>

      <div style={S.grid2}>
        {/* Datos del negocio */}
        <div style={S.card}>
          <div style={S.cardHdr}><div style={S.cardTitle}>🏢 Datos del SaaS</div></div>
          <div style={S.cardBody}>
            {msgNegocio && <div style={S.success}>{msgNegocio}</div>}
            <div style={S.field}>
              <label style={S.label}>Nombre del sistema</label>
              <input style={S.input} value={negocio.nombre} onChange={e => setNegocio({...negocio, nombre: e.target.value})} />
            </div>
            <div style={S.field}>
              <label style={S.label}>Email de contacto</label>
              <input style={S.input} value={negocio.email} onChange={e => setNegocio({...negocio, email: e.target.value})} />
            </div>
            <div style={S.field}>
              <label style={S.label}>Teléfono de soporte</label>
              <input style={S.input} value={negocio.tel} onChange={e => setNegocio({...negocio, tel: e.target.value})} />
            </div>
            <div style={S.field}>
              <label style={S.label}>Dominio principal</label>
              <input style={{ ...S.input, color:'#7A8F89', background:'#F8F8F8' }} value={negocio.dominio} disabled />
              <div style={{ fontSize:11, color:'#7A8F89', marginTop:4 }}>🔒 El dominio no se puede cambiar desde aquí</div>
            </div>
            <button style={S.btnSave} onClick={guardarNegocio}>✓ Guardar datos</button>
          </div>
        </div>

        {/* Credenciales */}
        <div style={S.card}>
          <div style={S.cardHdr}><div style={S.cardTitle}>🔐 Credenciales de acceso</div></div>
          <div style={S.cardBody}>
            {msgCreds   && <div style={S.success}>{msgCreds}</div>}
            {errorCreds && <div style={S.danger}>⚠️ {errorCreds}</div>}
            <div style={S.field}>
              <label style={S.label}>Usuario actual</label>
              <input style={{ ...S.input, color:'#7A8F89', background:'#F8F8F8' }} value={creds.usuarioActual} disabled />
            </div>
            <div style={S.field}>
              <label style={S.label}>Nuevo usuario (opcional)</label>
              <input style={S.input} placeholder="Dejar vacío para no cambiar" value={creds.nuevoUsuario} onChange={e => setCreds({...creds, nuevoUsuario: e.target.value})} />
            </div>
            <div style={S.divider} />
            <div style={S.field}>
              <label style={S.label}>Contraseña actual</label>
              <input style={S.input} type="password" placeholder="••••••••" value={creds.passActual} onChange={e => setCreds({...creds, passActual: e.target.value})} />
            </div>
            <div style={S.field}>
              <label style={S.label}>Nueva contraseña (opcional)</label>
              <input style={S.input} type="password" placeholder="Mínimo 8 caracteres" value={creds.passNueva} onChange={e => setCreds({...creds, passNueva: e.target.value})} />
            </div>
            <div style={S.field}>
              <label style={S.label}>Confirmar nueva contraseña</label>
              <input style={S.input} type="password" placeholder="Repite la nueva contraseña" value={creds.passConfirm} onChange={e => setCreds({...creds, passConfirm: e.target.value})} />
            </div>
            <button style={S.btnSave} onClick={guardarCreds}>✓ Actualizar credenciales</button>
          </div>
        </div>
      </div>

      {/* Notificaciones */}
      <div style={S.card}>
        <div style={S.cardHdr}><div style={S.cardTitle}>🔔 Notificaciones</div></div>
        <div style={S.cardBody}>
          {[
            { key:'pagoVencido',   label:'Alerta de pago vencido',       sub:'Notificar cuando un negocio no haya pagado' },
            { key:'proximoVencer', label:'Aviso de próximo vencimiento',  sub:'Notificar 3 días antes de que venza una suscripción' },
            { key:'nuevaRegistro', label:'Nuevo negocio registrado',      sub:'Notificar cuando se registre un nuevo cliente' },
            { key:'waPagoVencido', label:'Envío automático por WhatsApp', sub:'Enviar mensaje de cobro automático al vencer' },
          ].map(item => (
            <div key={item.key} style={{ ...S.toggleRow, ...(item.key === 'waPagoVencido' ? { borderBottom:'none' } : {}) }}>
              <div>
                <div style={S.toggleLbl}>{item.label}</div>
                <div style={S.toggleSub}>{item.sub}</div>
              </div>
              <button
                style={{ ...S.toggle, background: notif[item.key] ? '#075E54' : '#E4EDE8' }}
                onClick={() => toggleNotif(item.key)}>
                <div style={{ position:'absolute', top:3, left: notif[item.key] ? 21 : 3, width:16, height:16, borderRadius:'50%', background:'white', transition:'left .2s' }} />
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}